var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCzechia01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282.65 282.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .czechia-1 {\n        fill: #d7141a;\n      }\n\n      .czechia-2 {\n        fill: #fff;\n      }\n\n      .czechia-3 {\n        fill: #11457e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "czechia-2",
    d: "M282.65,141.33h-141.33L21.68,66.07C46.7,26.37,90.93,0,141.33,0c78.05,0,141.33,63.27,141.33,141.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "czechia-1",
    d: "M282.65,141.33c0,78.05-63.27,141.33-141.33,141.33-50.39,0-94.62-26.37-119.64-66.07l119.64-75.26h141.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "czechia-3",
    d: "M141.33,141.33L21.68,216.59C7.95,194.8,0,168.99,0,141.33s7.95-53.47,21.68-75.26l119.64,75.26Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzechia01);
export default __webpack_public_path__ + "static/media/Czechia-01.d42c3d5dde5c0c73a9abb882829d26ce.svg";
export { ForwardRef as ReactComponent };